import getDatesIntervalWithSubtractMinutes from '../../../localUtils/getDatesIntervalWithSubtractMinutes'

export default function getLastHourAgo() {
  const hourInMinutes = 60

  const dates = getDatesIntervalWithSubtractMinutes(hourInMinutes)

  const options = {
    name: 'LAST_HOUR',
    label: 'Ultima hora',
    ...dates,
  }

  return options
}
